import axios from 'axios'

export default {
    getMenu: (type) => axios.get('menu/'+type),
    getParameters: () => axios.get('parameters'),
    getProductsByLink: (code) => axios.get(code+'/filtered-products'),
}